import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import validationActions from './validation-actions'

/*

Exposes the validate() action to the wrapped component. The validation action
utilises the state.form.getData() state under the hood, which will in turn
supply any found error to the errors module.

*/

const mapStateToProps = (state, initialProps) => ({
    ...initialProps
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        validation: bindActionCreators( validationActions, dispatch )
    }
})


export const withValidation = (Wrapped:React.ComponentClass) =>{

    return connect(mapStateToProps, mapDispatchToProps)(Wrapped)

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/validation/index.tsx